module.exports = __webpack_public_path__ + "img/res_all.7c3a7734.svg";